'use client';

import NavFooterLayout from 'src/components/Layouts/NavFooterLayout';
import TradePageGridAndCustomiser from 'src/components/TradePageGrid/TradePageGridAndCustomiser';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { OrderbookSubscriptionProvider } from 'src/providers/orderbook/OrderbookSubscriptionProvider';
// TODO: Uncomment for USD1 campaign launch
// import { useUSD1CampaignToast } from 'src/utils/usd1CampaignToast';
import { useEffect } from 'react';

export default function Index() {
	const isMobileScreenSize = useIsMobileScreenSize();
	// TODO: Uncomment for USD1 campaign launch
	// const { showUSD1CampaignToast } = useUSD1CampaignToast();

	useEffect(
		() => {
			// TODO: Uncomment for USD1 campaign launch
			// Show USD1 campaign toast notification when the trade page loads
			// showUSD1CampaignToast();
		},
		[
			/* showUSD1CampaignToast */
		]
	);

	return (
		<OrderbookSubscriptionProvider>
			<NavFooterLayout overflowAuto hideScroll={isMobileScreenSize}>
				<TradePageGridAndCustomiser />
			</NavFooterLayout>
		</OrderbookSubscriptionProvider>
	);
}
